<template lang="pug">
  section.challenge-control(ref='control')
    .challenge-control__container(:class="{'fixed':sticky, 'static':!sticky}")
      .challenge-control__wrapper
        lei-btn.challenge-control__save(
          type="cyprus"
          fill
          @click="saveChanges"
          v-if="challengeMode"
          data-test="review-changes-button"
        ) Review changes
        lei-btn(fill @click="cancelChanges" v-if="challengeMode") Cancel
</template>
<script>
import { mapMutations, mapState, mapGetters, mapActions, } from 'vuex'
import {
  TOGGLE_SUMMARY_MODAL,
  CLEAR_CHALLENGE,
} from '@/store/modules/record/modules/challenge/mutations-types'
import { TOGGLE_DISPLAY_SECTION, } from '@/store/modules/record/mutations-types'
import Challenge from '@/mixins/challenge'
import { EventBus, } from '@/event-bus'
import LeiBtn from '../lei-components/LeiBtn'
import IntersectionObserverMixin from '@/mixins/IntersectionObserverMixin'
import { stopControlFixed, } from '@/utils/helpers'

export default {
  components: {
    LeiBtn,
  },
  mixins: [
    Challenge,
    IntersectionObserverMixin(
      [ 'control', ], stopControlFixed, {
        root: null,
        rootMargin: '-90px',
        threshold: 0.001,
      }
    ),
  ],
  props: {
    sticky: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      currentState: false,
      confirmText: 'You are leaving this page, if you proceed all entered data will be lost. ' +
          'Do you want to leave this page?',
    }
  },
  computed: {
    ...mapState('record', [ 'showEmptyFields', ]),
  },
  methods: {
    saveChanges () {
      EventBus.$emit('challenge-save-changes')
      this.toggleSummary(true)
    },
    cancelChanges () {
      this.$confirm(this.confirmText, {
        type: 'warning',
      }).then(() => {
        this.toggleDisplayEmptyFields(this.currentState)
        this.clearChallenge()
        EventBus.$emit('challenge-clear')
        this.$router.push({ name: 'RecordDetailsPage', })
        this.$message({
          type: 'info',
          message: 'Challenge canceled',
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Challenge continues',
        })
      })

    },
    toggleDisplayEmptyFields (value) {
      this.toggleDisplay({
        property: 'showEmptyFields',
        value,
      })
    },

    ...mapMutations('record/challenge', {
      toggleSummary: TOGGLE_SUMMARY_MODAL,
      clearChallenge: CLEAR_CHALLENGE,
    }),
    ...mapMutations('record', {
      toggleDisplay: TOGGLE_DISPLAY_SECTION,
    }),
  },
}
</script>
<style lang="stylus" scoped>
  @import "../../assets/styles/variables.styl"
  .challenge-control
    justify-content start
    padding 15px 0

    .static
      position: static!important

    .fixed
      position fixed
      background $white-color
      padding 20px 0
      border-top 5px solid $primary-color-light-4
      bottom 0
      z-index 10
      left  0
      @media screen and (max-width: $laptop-xl)
        bottom 0
      .challenge-control__wrapper
        min-width 1280px
        width auto
        @media screen and (max-width: $laptop-l)
          width 85%
          min-width 1000px
        @media screen and (max-width: $laptop)
          min-width: auto
          width: 100%
          padding: 0 20px

    &__container
      width 100%
      display flex
      align-items center
      flex-direction column

    &__wrapper
      display flex
      flex-direction row
      width 100%

    &__save
      margin-right 10px
</style>



// WEBPACK FOOTER //
// src/components/challenge-components/ChallengeControlSection.vue